// extracted by mini-css-extract-plugin
module.exports = {"screen":"Modal_screen__2KVcV","show":"Modal_show__1k4KI","window":"Modal_window__3b9Hh","container":"Modal_container__3Wm3u"};